module.exports = __webpack_public_path__ + "6a518593b0512bb40a4af645f72ce54e.jpg";